import { assetTypes } from "../actions/asset_old";

const initialState = {
  isLoading: false,
  isDownloaded: "",
  error: null,
  filters: {
    isLoaded: false,
    assetType: "",
    assetName: "",
    assetStatus:"",
    organization: "",
    location: "",
    lifeCycleStatus: "",
    productiveStatus: "",
    idleStatus: "",
    lostStatus: "",
    sort: [
      {
        field: "createdon",
        order: "desc",
      },
    ],
    pagenumber: 0,
    limitnumber: 50,
  },
  data: {
    assetTypeList: [
      {
        label: "BIN",
        value: "BIN",
      },
      {
        label: "CAN",
        value: "CAN",
      },
      {
        label: "POD",
        value: "POD",
      },
      {
        label: "HOSE",
        value: "HOSE",
      },
      {
        label: "UNKNOWN",
        value: "UNKNOWN",
      },
    ],
    statusTypeList: [
      {
        label: "OK",
        value: "OK",
      },
      {
        label: "IDLE",
        value: "IDLE",
      },
      {
        label: "LOST",
        value: "LOST",
      },
      {
        label: "IN-TRANSIT",
        value: "IN-TRANSIT",
      },
      {
        label: "UNKNOWN",
        value: "UNKNOWN",
      },
    ],
    lifeCycleFilterList: [
      {
        label: "ALL",
        value: "",
      },
      {
        label: "AT PLANT",
        value: "AT PLANT",
      },
      {
        label: "AT YARD (OB)",
        value: "AT YARD (OB)",
      },
      {
        label: "AT DC",
        value: "AT DC",
      },
      {
        label: "AT YARD (IB)",
        value: "AT YARD (IB)",
      },
      {
        label: "DEPARTED PLANT",
        value: "DEPARTED PLANT",
      },
      {
        label: "DEPARTED YARD (OB)",
        value: "DEPARTED YARD (OB)",
      },
      {
        label: "YARD (IB)",
        value: "YARD (IB)",
      },
    ],
    productiveFilterList: [
      {
        label: "ALL",
        value: "",
      },
      {
        label: "PRODUCTIVE",
        value: "PRODUCTIVE",
      },
      {
        label: "UNPRODUCTIVE",
        value: "UNPRODUCTIVE",
      },
    ],
    idleFilterList: [
      {
        label: "ALL",
        value: "",
      },
      {
        label: "OK",
        value: "OK",
      },
      {
        label: "IDLE",
        value: "IDLE",
      },
    ],
    lostFilterList: [
      {
        label: "ALL",
        value: "",
      },
      {
        label: "OK",
        value: "OK",
      },
      {
        label: "LOST",
        value: "LOST",
      },
    ],
    assetList: [],
    devices: [],
    locations: [],
    organizations: [],
  },
};

const assetReducer = (state = initialState, action) => {
  switch (action.type) {
    case assetTypes.FETCH_REQUEST:{
      return {
        ...state,
        isLoading: !state?.filters.isLoaded,
      };
    }
    case assetTypes.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          ...action.payload,
        },
        filters: {
          ...state.filters,
          isLoaded: true,
        },
        error: null,
      };
    case assetTypes.UPDATE_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
          sort: action.payload.sort
        },
      };
    case assetTypes.FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        data: {
          ...state.data,
          assetList: [],
        },
        error: action.payload,
      };
    case assetTypes.DOWNLOAD_REQUEST:
      return {
        ...state,
        isDownloaded: "Downloading....",
        isLoading: true,
      };
    case assetTypes.DOWNLOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isDownloaded: "Downloaded",
      };
    case assetTypes.DOWNLOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        isDownloaded: "Something Went Wrong",
        error: action.payload,
      };
    default:
      return state;
  }
};

export default assetReducer;